module.exports = __webpack_public_path__ + "static/img/产品banner.71c84a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ds-img/产品banner.png
// module id = hCll
// module chunks = 0